import ICommand from "@/types/interfaces/i-command";
import esquireClient from "@/modules/esquire-client";
import {AxiosError} from "axios";
import {HttpResource} from "@/types/enums";
import CommandFailedError from "@/types/errors/command-failed-error";
import ErrorData from "@/http/data/error-data";

export default class FinishUnitCheckCommand implements ICommand {
    constructor(private id: number) {}

    async execute(): Promise<void> {
        const url = `${HttpResource.UnitChecks}/${this.id}`;

        const response = await esquireClient.put(url, {
            command: "finish"
        }).catch((e: AxiosError) => e.response);

        if (!response || response.status !== 200) {
            const alert = (response?.data as ErrorData).message;

            throw new CommandFailedError(`Finish unit check (${this.id}) command failed.`, alert);
        }
    }
}